import createBrowserHistory from 'history/lib/createBrowserHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createBrowserHistory);


//////////////////
// WEBPACK FOOTER
// ../~/_react-router@3.2.4@react-router/es/browserHistory.js
// module id = 1558
// module chunks = 1